import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  rtl: true,
  theme: {
    themes: {
      light: {
        primary: '#584a01',
        secondary: '#1a617c',
        accent: '#584a01',
        success: '#51a057',
        error: '#af4545'
      }
    }
  }
});
